// extracted by mini-css-extract-plugin
export default {"wrap-text-box":"TextBox_wrap-text-box__GR+nP"};